const Selectors = {
  widget: {
    waitFor: "#general-info",
    target: ".book_inner",
    mobileWidgetTarget: ".navbar",
    mobileWidgetFixedTarget: ".navbar",
    mobileStaticNavBar: ".page-header-inner.container",
    mobileStaticNavBarContentBellow: ".container2",
    currency: ".last span, .grand_total .row .text-right, .grand_total, .av-rate-price ",
    displaySubtotal:
      ".selected_rooms_price:not(.selected_rooms_price.hide), .sum .grand_total",
    widget: "#guestbook-widget",
    stickyWidget: "#guestbook-sticky-widget",
  },
  ratesPage: {
    waitFor: [
      ".av-rate-price",
      {
        type: "WINDOW_VAR_EXISTS",
        script:
          "var val = window.CBBooking; script.setAttribute('data-val', val);",
      },
    ],
    contentChangeTarget: ".av-rate-price",
    rates: ".av-rate-price:not(:has(.new-price)), .new-price",
    ratesMessage: ".gb-rates-message",
  },
  paymentPage: {
    waitFor: ".checkout .reserve_total",
    subtotal: ".reserve_total .sum:not(.total_adults .sum, .total_child .sum)",
    totalWithTaxes: ".grand_total .sum",
    roomNames: ".reserve_info .short_info2",
    contentChangeTarget: ".selected_rooms_price",
    firstName: "input#first_name",
    lastName: "input#last_name",
    email: "input#email",
    enrollmentTarget: "input#phone",
    enrollmentMessageContainer: "#guestbook-enrollment",
    saveInfoTarget: "button.finalize",
  },
  confirmationPage: {
    waitFor: ".reserve_number",
    messageTarget: ".table-responsive",
    confirmationNumber: ".reserve_number",
    confirmationMessageContainer: "#guestbook-confirm",
  },
  cancellationPage: {
    target: "app-cancel-booking-confirmation",
  },
};

export default Selectors;
